import jQuery from "jquery";

(function ($) {
  $(window).on("scroll", function () {
    var stickytop = $("#header.sticky-top .bg-transparent");
    var stickytopslide = $("#header.sticky-top-slide");

    if ($(this).scrollTop() > 1) {
      stickytop.addClass("sticky-on-top");
      stickytop
        .find(".logo img")
        .attr("src", stickytop.find(".logo img").data("sticky-logo"));
    } else {
      stickytop.removeClass("sticky-on-top");
      stickytop
        .find(".logo img")
        .attr("src", stickytop.find(".logo img").data("default-logo"));
    }

    if ($(this).scrollTop() > 180) {
      stickytopslide.find(".primary-menu").addClass("sticky-on");
      stickytopslide
        .find(".logo img")
        .attr("src", stickytopslide.find(".logo img").data("sticky-logo"));
    } else {
      stickytopslide.find(".primary-menu").removeClass("sticky-on");
      stickytopslide
        .find(".logo img")
        .attr("src", stickytopslide.find(".logo img").data("default-logo"));
    }
  });

  jQuery(document).on("click", ".nav-link.smooth-scroll", function () {
    jQuery(".nav-link.smooth-scroll").removeClass("active");
    jQuery(this).addClass("active");
  });
})(jQuery);
